import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const TimeFilters = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 4px;
`;
